"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageTimingsInFirstScreen = exports.isInFirstScreen = void 0;
var tslib_1 = require("tslib");
var logger_1 = tslib_1.__importDefault(require("./logger"));
var util_1 = require("./util");
/**
 * judge whether a node is in first screen area (top: 0, left: 0, width: 100vw, height: 100vh)
 * @param {*} currentNode
 */
function isInFirstScreen(currentNode, scrollDom) {
    var _a;
    if (!currentNode) {
        return false;
    }
    var _b = (currentNode === null || currentNode === void 0 ? void 0 : currentNode.getBoundingClientRect()) || {}, top = _b.top, left = _b.left, right = _b.right, bottom = _b.bottom;
    // display:none element
    if (!top && !bottom) {
        return false;
    }
    // 如果在结构上的首屏内（上下、左右）
    // 当整体页面有绝对定位时，则选实际滚动的DOM作为标准，window的滚动已经失效
    var scrollTop;
    if (scrollDom) {
        scrollTop = (_a = document.getElementById(scrollDom)) === null || _a === void 0 ? void 0 : _a.scrollTop;
    }
    else {
        scrollTop = window.scrollY || window.pageYOffset;
    }
    if (scrollTop + top < window.innerHeight && right > 0 && left < window.innerWidth) {
        return true;
    }
    return false;
}
exports.isInFirstScreen = isInFirstScreen;
function escapeProtocol(name) {
    var index = name.indexOf(':');
    return index > -1 ? name.slice(index + 1) : name;
}
/**
 * filter img timing resource that only in first screen, excluding ignored element
 * @param {*} ignoreTag
 */
function getImageTimingsInFirstScreen(ignoreTag, imgPattern, scrollDom) {
    // only when performance supported
    if (!window.performance || !window.performance.getEntriesByType) {
        return [];
    }
    var result = [];
    try {
        // retrieve img resource timing
        var imageResources = window.performance.getEntriesByType('resource')
            // filter img and background image timing resource
            .filter(function (s) { return s.initiatorType === 'img' || s.initiatorType === 'css'; })
            .map(function (s) {
            return {
                name: s.name,
                responseEnd: s.responseEnd,
                connectEnd: s.connectEnd,
                duration: s.duration,
            };
        });
        // filter first screen img resource
        var domImages_1 = getDomImgs(ignoreTag, imgPattern, scrollDom);
        logger_1.default.log('firstscreen image src are: ', domImages_1);
        // filter first screen img timing, in descend order
        result = imageResources
            .filter(function (img) { return domImages_1.indexOf(img.name) > -1; })
            .map(function (s) {
            var time = s.responseEnd || s.connectEnd + s.duration;
            return {
                name: s.name,
                time: time,
            };
        })
            .sort(function (s1, s2) { return s2.time - s1.time; })
            .reduceRight(function (prev, cur) {
            if (prev.every(function (it) { return it.name !== cur.name; })) {
                prev.unshift(cur);
            }
            return prev;
        }, []);
        logger_1.default.log('首屏内图片的加载时间', result);
        return result.map(function (img) { return img.time; });
    }
    catch (err) {
        result = [];
    }
    return result;
}
exports.getImageTimingsInFirstScreen = getImageTimingsInFirstScreen;
function isBase64Img(src) {
    return src && src.slice(0, 10) === 'data:image';
}
function formatImageUrl(src) {
    var link = document.createElement('a');
    link.href = src;
    return link.href;
}
/**
 * extract img src from background prop
 * @param {*} src
 */
function getImgSrcFromBackground(src, imgPattern) {
    var imgSrc;
    var matches = src.match(/url\(.*?\)/g);
    if (matches && matches.length) {
        // use the last one
        var urlStr = matches[matches.length - 1];
        var innerUrl = urlStr.replace(/^url\([\'\"]?/, '').replace(/[\'\"]?\)$/, '');
        // only url has .[img] extensions, but not base64
        if (imgPattern.test(innerUrl) && !isBase64Img(innerUrl)) {
            imgSrc = innerUrl;
        }
    }
    return imgSrc;
}
/**
 * filter both img and node with background-image prop setted
 * @param {*} node
 */
function getImgSourceFromDom(node, imgPattern) {
    if (node.nodeName.toUpperCase() === 'IMG') {
        // also include img with data-srcset attribute
        return node.getAttribute('data-srcset') || node.getAttribute('src');
    }
    else {
        var computedStyle = window.getComputedStyle(node);
        var backgroundProp = computedStyle.getPropertyValue('background-image') ||
            computedStyle.getPropertyValue('background');
        return getImgSrcFromBackground(backgroundProp, imgPattern);
    }
}
/**
 * using NodeIterator to filter all dom element, including elements with background-image setted.
 * but node with @ignoreTag attribute specified will be ignored
 * @param {*} ignoreTag
 */
function getDomImgs(ignoreTag, imgPattern, scrollDom) {
    var domImages = [];
    try {
        var iterator = document.createNodeIterator(document.body, NodeFilter.SHOW_ELEMENT, {
            acceptNode: function (node) {
                if (node && util_1.isFunction(node.getAttribute) && !node.hasAttribute("" + ignoreTag)) {
                    return NodeFilter.FILTER_ACCEPT;
                }
                else {
                    return NodeFilter.FILTER_REJECT;
                }
            },
        });
        var currentNode = iterator.nextNode();
        while (currentNode) {
            var imgSrc = getImgSourceFromDom(currentNode, imgPattern);
            if (!imgSrc) {
                currentNode = iterator.nextNode();
                continue;
            }
            if (isInFirstScreen(currentNode, scrollDom) && !isBase64Img(imgSrc)) {
                domImages.push(formatImageUrl(imgSrc));
            }
            currentNode = iterator.nextNode();
        }
    }
    catch (e) {
        logger_1.default.log('getDomImgs err');
    }
    return domImages;
}
//# sourceMappingURL=img.js.map